import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { ApplicationClientCommonModule, ServiceResponseModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { TMCTableModule } from '@sdbn/appclient';
import { TransportInfoPanelModule } from '@sdbn/appclient';
import { LinkTransportsDialogComponent } from './component/link-transports-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    TransportInfoPanelModule,
    TMCTableModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule
  ],
  declarations: [LinkTransportsDialogComponent]
})
export class LinkTransportsModule { }
